export enum Types {
	ATUALIZAR_PARAMETRO_SISTEMA = '@SGU/ATUALIZAR_PARAMETRO_SISTEMA',
	ATUALIZAR_PARAMETRO_SISTEMA_SUCCESS = '@SGU/ATUALIZAR_PARAMETRO_SISTEMA_SUCCESS',
	ATUALIZAR_PARAMETRO_SISTEMA_FAILURE = '@SGU/ATUALIZAR_PARAMETRO_SISTEMA_FAILURE',
	ATUALIZAR_PARAMETRO_SISTEMA_CLEAR = '@SGU/ATUALIZAR_PARAMETRO_SISTEMA_CLEAR',
}

export interface AtualizarParametroSistema {
	status: number;
	data: null | ParametroSistemaData;
}

interface ParametroSistemaData {
	status: string;
	statusMensagem: string;
}

export interface AtualizarParametroSistemaRequest {
	id?: number | string;
	sigla: string;
	descricao: string;
	valor: string;
}
